"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AudioBitrateSelect = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _AudioBitrateSelect = require("./AudioBitrateSelect.styled");
var _constants = require("../../constants");
var AudioBitrateSelect = exports.AudioBitrateSelect = function AudioBitrateSelect(_ref) {
  var onAudioBitrateChanged = _ref.onAudioBitrateChanged;
  return _react["default"].createElement(_AudioBitrateSelect.StyledSelectInput, {
    onChange: function onChange(event) {
      return onAudioBitrateChanged(event.target.value);
    }
  }, _constants.rates.map(function (rate) {
    return _react["default"].createElement("option", {
      key: rate.id,
      value: rate.value
    }, rate.label);
  }));
};
AudioBitrateSelect.propTypes = {
  onAudioBitrateChanged: _propTypes.func.isRequired
};